var _rect, _rect2, _rect3, _ellipse, _ellipse2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkHangeul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 68,
    height: 68,
    rx: 18,
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 34,
    width: 30,
    height: 7,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 7,
    height: 12,
    rx: 1,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 52,
    rx: 14,
    ry: 10,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 52,
    rx: 7,
    ry: 4.8,
    fill: "#193A73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 23L59.2 32.2L68.4 35.4L59.2 38.6L56 47.8L52.8 38.6L43.6 35.4L52.8 32.2L56 23Z",
    fill: "#FFD23D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    y1: 12,
    x2: 66,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122D61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkHangeul);
export default __webpack_public_path__ + "static/media/bookmark_hangeul.0cfaa21fec09ecdb46037448491feabf.svg";
export { ForwardRef as ReactComponent };